import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedDataService } from './services/app/shared-service/shared-data.service';
import { AuthService } from './components/auth/service/auth.service';
import { NavigationStart, Router } from '@angular/router';
import { DateTimeAdapter } from '@danielmoncada/angular-datetime-picker';
import * as moment from 'moment-timezone';
import { Observable, takeUntil } from 'rxjs';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PermissionService } from './services/app/permission-access-service/permissionBased.service';
import { WebPushService } from './services/app/web-push/web-push.service';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  isLoggedIn = false;

  constructor(
    private sharedDataService: SharedDataService,
    private permissionService: PermissionService,
    private webPushService: WebPushService
  ) { }

  ngOnInit() {
    this.getUser();
    // Initialize Web Push Service Worker on application load
    this.webPushService.initServiceWorker().catch(err => {
      console.warn('Web push initialization issue:', err);
    });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(untilDestroyed(this))
      .subscribe(user => {
        if (user) {
          this.isLoggedIn = true;
          this.permissionService.setUser(user);
          // Sync subscription with user profile
          this.webPushService.syncSubscriptionStatus();
        } else {
          this.isLoggedIn = false;
          this.permissionService.setUser(null);
        }
      });
  }

  ngOnDestroy(): void {
  }
}
